import { exchangeMagicTokens } from './exchange-magic-tokens.ts'

export default {
  exchangeMagicTokens
}
